import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';
/**
 * 간단한 정보 표시용 모달 컴포넌트
 *
 * 사용 예시:
 * - 지원 언어 목록
 * - 도움말/안내 메시지
 * - 상세 정보 조회
 *
 * @example
 * ```tsx
 * <InfoModal
 *   isOpen={isOpen}
 *   onClose={onClose}
 *   title="지원 언어"
 * >
 *   <ul>
 *     <li>한국어</li>
 *     <li>English</li>
 *     <li>日本語</li>
 *   </ul>
 * </InfoModal>
 * ```
 */ export var InfoModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, title = param.title, children = param.children, _param_size = param.size, size = _param_size === void 0 ? 'sm' : _param_size, _param_closeButtonText = param.closeButtonText, closeButtonText = _param_closeButtonText === void 0 ? '닫기' : _param_closeButtonText, _param_isDismissable = param.isDismissable, isDismissable = _param_isDismissable === void 0 ? true : _param_isDismissable, _param_hideCloseButton = param.hideCloseButton, hideCloseButton = _param_hideCloseButton === void 0 ? false : _param_hideCloseButton, _param_showFooter = param.showFooter, showFooter = _param_showFooter === void 0 ? true : _param_showFooter, footer = param.footer;
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isOpen,
        onClose: onClose,
        size: size,
        placement: "center",
        isDismissable: isDismissable,
        hideCloseButton: hideCloseButton
    }, /*#__PURE__*/ React.createElement(ModalContent, {
        onClick: function(e) {
            return e.stopPropagation();
        }
    }, function(onClose) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ModalHeader, {
            className: "flex flex-col gap-1"
        }, title), /*#__PURE__*/ React.createElement(ModalBody, null, children), showFooter && /*#__PURE__*/ React.createElement(ModalFooter, null, footer || /*#__PURE__*/ React.createElement(Button, {
            color: "primary",
            onPress: onClose
        }, closeButtonText)));
    }));
};
